export default "__VITE_ASSET__D8dk_ipo__"